export const buttonStyles = {
  base: `
    inline-flex items-center justify-center
    font-medium rounded-lg
    transition-all duration-150
    focus:outline-none focus:ring-2 focus:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
  `,

  variants: {
    primary: `
      bg-gradient-to-r from-primary-400 to-primary-500
      text-white
      hover:from-primary-500 hover:to-primary-600
      focus:ring-primary-400
      shadow-sm hover:shadow-md
      active:scale-95
    `,
    secondary: `
      bg-slate-100 dark:bg-slate-700
      text-slate-700 dark:text-slate-200
      hover:bg-slate-200 dark:hover:bg-slate-600
      focus:ring-slate-400
    `,
    outline: `
      bg-transparent
      border border-slate-300 dark:border-slate-600
      text-slate-700 dark:text-slate-300
      hover:bg-slate-50 dark:hover:bg-slate-800
      focus:ring-primary-400
    `,
    ghost: `
      bg-transparent
      text-slate-600 dark:text-slate-400
      hover:bg-slate-100 dark:hover:bg-slate-800
      hover:text-slate-900 dark:hover:text-slate-200
      focus:ring-slate-400
    `,
    danger: `
      bg-red-500 text-white
      hover:bg-red-600
      focus:ring-red-400
      shadow-sm hover:shadow-md
      active:scale-95
    `,
    success: `
      bg-emerald-500 text-white
      hover:bg-emerald-600
      focus:ring-emerald-400
      shadow-sm hover:shadow-md
      active:scale-95
    `,
  },

  sizes: {
    sm: 'px-3 py-1.5 text-xs gap-1.5',
    md: 'px-4 py-2 text-sm gap-2',
    lg: 'px-5 py-2.5 text-base gap-2',
    xl: 'px-7 py-3.5 text-base gap-2.5',
  },
};
